<template>
  <div
    v-if="subtotal >= 5000"
    id="tarjouspyynto"
    class="conversion-stripe conversion-stripe--rfp"
  >
    <div class="conversion-stripe__container conversion-stripe__container--rfp">
      <p class="conversion-stripe__heading conversion-stripe--rfp__heading">
        {{ conversion.heading }}
      </p>

      <p class="conversion-stripe__text conversion-stripe--rfp__text">
        {{ conversion.text }}
      </p>

      <input
        type="submit"
        name="offer_request_without_shipping"
        class="btn btn--block"
        :value="conversion.button_text"
        @click="submit()"
      >
    </div>
  </div>
</template>

<script>
export default {
    props: {
        conversion: {
            type: Object,
            default: function() {
                return {};
            },
        },
    },
    computed: {
        subtotal: function() {
            return this.$store.getters.getTotals.subtotal;
        },
        errorsInBillingForm: function() {
            return !this.$store.getters.getBillingAddress.valid;
        },
    },

    methods: {
        submit: function() {
            if (this.errorsInBillingForm) {
                event.preventDefault();
                let billingFormPos = document.getElementById('billing-form').offsetTop;
                window.scrollTo(0, billingFormPos - 80);
            }
        },
    },
}
</script>
